//import { Vector3 } from 'three';
import * as THREE from 'three/build/three.module';
import { J3CameraUtils } from './J3CameraUtils';
import { J3PanelBase } from './J3PanelBase';
import { TagInfo } from './J3TypeList';

export class J3Billboar2DdHelper extends J3PanelBase {
    container: HTMLElement;
    section: HTMLElement;
    imgElement: HTMLImageElement;
    imgDir: string;
    tagInfos = [];
    currentTagInfo;

    constructor(public wrapper: THREE.Object3D = null, public prefix: string = '', public groupid: string = 'none', public enable: boolean = true, public imagecommon, public tagcommon, public data, public debug) {
        // wrapper //親オブジェクト
        // id:string = 'none'; //ビルボードグループのID名
        // enable:boolean = true;   //ビルボードを有効にするか？
        // imagecommon;     //イメージの共通データ
        // tagcommon;     //タグの共通データ
        // data;   //ビルボードのデータ JSON-'billboards'
        super();
        console.log('J3Billboard2DHelper', groupid, enable, imagecommon.imagedir, tagcommon.image, data[0].name);
        wrapper.name = groupid; //ラッパーの名前はグループIDにする
        this.imgDir = imagecommon.imagedir;
        //画像用HTMLの作成
        this.container = document.querySelector('#' + imagecommon.containerID) as HTMLElement;
        if (this.container) {

            // div 最上位のDOM
            const imageID = imagecommon.imageID;
            //DOM要素を作成
            this.section = document.createElement('section');
            this.section.setAttribute('id', imageID);
            const div = document.createElement('div');
            div.classList.add('popup');
            if (imagecommon?.css?.class) {
                div.classList.add(imagecommon.css.class);
            }
            this.section.appendChild(div);
            this.container.appendChild(this.section);

            //DOM構造を最下位から作成
            //div21 'col-xxs-12' メイン画像（srcは仮アサイン）
            const img2 = document.createElement('img');
            img2.classList.add('billboard');
            img2.src = '';  //仮
            this.imgElement = img2;  //img要素をプロパティ化しておく
            const div21 = document.createElement('div');
            div21.classList.add('col-xxs-12');
            div21.appendChild(img2);

            // テキストリンク（テキストは仮）
            if (imagecommon.addLink) {
                const a = document.createElement('a');
                a.innerHTML = '';   //仮
                a.href = '#';       //仮
                a.target = imagecommon.target;
                div21.appendChild(a);
            }

            //div2 'row box'
            const div2 = document.createElement('div');
            div2.classList.add('row');
            div2.classList.add('box');
            div2.appendChild(div21);
            div.appendChild(div2);

            //「閉じる」ボタン
            const span = document.createElement('span');
            span.classList.add('close');
            if (imagecommon?.closeButton?.css?.class) {
                span.classList.add(imagecommon.closeButton.css.class);
            }
            const button = document.createElement('button');
            button.type = 'button';
            button.setAttribute('id', '##');
            const img = document.createElement('img');
            const closeBtnPath = imagecommon.closeButton.dir + imagecommon.closeButton.image;
            img.src = closeBtnPath;
            button.appendChild(img);
            span.appendChild(button);
            div21.appendChild(span);

            //「ENTER」ボタン（オプション）
            if (imagecommon?.linkButton?.enable) {
                //「ENTER」ボタン
                const span1 = document.createElement('span');
                span1.classList.add('enterPop');
                if (imagecommon?.linkButton?.css?.class) {
                    span1.classList.add(imagecommon.linkButton.css.class);
                }
                const button1 = document.createElement('button');
                button1.type = 'button';
                button1.setAttribute('id', '##');
                const img1 = document.createElement('img'); //「ENTER」ボタン
                img1.src = imagecommon.linkButton.dir + imagecommon.linkButton.image;
                button1.appendChild(img1);
                span1.appendChild(button1);
                div21.appendChild(span1);
                button1.addEventListener("click", (e: Event) => {
                    console.log('Enter Button');
                    this.GoToURL();
                });
            }

            //タイトル（オプション）
            if (imagecommon.addTitle) {
                const p = document.createElement('p');
                p.classList.add('pop_title');
                p.innerHTML = '';   //仮
                div.appendChild(p);
            }

            // 表示・非表示の対象を設定
            //console.log('J3Billboard2DHelper');
            this.SetOverlay('overlay');
            this.SetOnOffTarget(this.section, true);

        } else {
            console.error('*** ERROR: containerID', imagecommon.containerID, 'not found');
        }
        //初期状態：イメージパネル閉
        this.Hide();

        //各パラメータの設定
        this.PrepareTags();

        //タグの位置をキーで調整
        if (this.debug.moveByKey != undefined && this.debug.moveByKey == true) {
            document.addEventListener('keydown', (e: Event) => this.KeyDownMethod(e));
        }
    }

    //キーダウン時のメソッド
    KeyDownMethod(evt) {
        this.MoveCurrentTag(evt); //画像の回転
    }

    MoveCurrentTag(evt) {
        if (this.currentTagInfo == null) return;
        //console.log('CurrentTag', this.currentTagInfo.name);
        var key = evt.key;
        var shift = evt.shiftKey;   //evt.shift:boolean
        //var option = evt.altKey;     //command or Windows key:boolean
        //console.log('MoveCurrentTag ', key, shift, option);
        //if (shift) {
        let delta: number = this.debug.normalInc;
        if (shift) {
            delta = this.debug.altInc;
        }

        //console.log('delta', delta);
        const currentTag = this.currentTagInfo.group;
        let pos = currentTag.position;
        if (key == 'ArrowLeft' || key == 'a') {
            //this.currentDome.dome.rotateOnAxis(axis, delta*this.degToRad); //rotateを使うとなぜか符号が反転する？
            currentTag.position.set(pos.x - delta, pos.y, pos.z);
        } else if (key == 'ArrowRight' || key == 'd') {
            currentTag.position.set(pos.x + delta, pos.y, pos.z);
        }
        else if (key == 'ArrowUp' || key == 'w') {
            currentTag.position.set(pos.x, pos.y, pos.z + delta);
        }
        else if (key == 'ArrowDown' || key == 's') {
            currentTag.position.set(pos.x, pos.y, pos.z - delta);
        }
        else if (key == 'e') {
            currentTag.position.set(pos.x, pos.y + delta, pos.z);
        }
        else if (key == 'q') {
            currentTag.position.set(pos.x, pos.y - delta, pos.z);
        }
        pos = currentTag.position;
        console.log('Tag Position', this.currentTagInfo.group, this.currentTagInfo.name, '[', pos.x.toFixed(2), ',', pos.y.toFixed(2), ',', pos.z.toFixed(2), ']');
        //}
    }

    Update(cameraUtils: J3CameraUtils) {
        //J3ThreeSubのUpdateループからコールされる
        this.FaceToCamera(cameraUtils, false);
    }

    FaceToCamera(cameraUtils: J3CameraUtils, forced = false) {
        if (cameraUtils == null) return;
        //タグをカメラに正対させる
        if (this.tagcommon.faceToCamera || forced) {
            for (const tagInfo of this.tagInfos) {
                //bill.tag.rotation.setFromRotationMatrix(cameraUtils.camera.matrix);
                //bill.image.rotation.setFromRotationMatrix(cameraUtils.camera.matrix);
                //bill.close.rotation.setFromRotationMatrix(cameraUtils.camera.matrix);
                tagInfo.group.rotation.setFromRotationMatrix(cameraUtils.camera.matrix);
            }
        }
    }

    PrepareTags(widthSegments = 4, heightSegments = 4) {
        if (this.wrapper == null) return;
        if (!this.enable) return;

        //タグ画像のロード。画像名を受けて画像をロードし、environments配列に格納する
        const geometry = new THREE.PlaneGeometry(1, 1, widthSegments, heightSegments);
        const textureLoader = new THREE.TextureLoader();
        //console.log(this.tagcommon.imagedir + this.tagcommon.image);
        textureLoader.load(this.tagcommon.imagedir + this.tagcommon.image, (texture) => {
            //console.log('Billboard tag load success', texture.name);
            texture.encoding = THREE.sRGBEncoding;
            const material = new THREE.MeshBasicMaterial({
                //const material = new THREE.MeshToonMaterial({
                map: texture,
                color: this.tagcommon.color,
                transparent: true,
                alphaTest: 0.5,
            });
            this.MakeTags(geometry, material);
        })
    }

    MakeTags(geometry: THREE.geometry, tagMaterial: THREE.material) {
        //各タグとビルボードと「閉じる」「リンク」ボタンの作成
        const degToRad = Math.PI / 180.0;
        for (const elem of this.data) {
            if (!elem.load) continue;    //スキップ

            //グループ
            const group = new THREE.Group();
            this.wrapper.attach(group);
            const idname = this.prefix;
            group.name = idname + '_' + this.groupid + '_' + elem.name;
            const pos = elem.pos;
            group.position.set(pos[0], pos[1], pos[2]);
            group.scale.set(1, 1, 1);

            //タグを作成
            let scl: number[];
            const quad = new THREE.Mesh(geometry, tagMaterial);
            group.attach(quad); //position/rotationをセットする前にグループに入れるとローカル座標での指定になる
            quad.name = idname + '_' + this.groupid + '_' + this.tagcommon.action + '_' + elem.name;
            quad.position.set(0, 0, 0);
            //const rot = elem.rot;
            const rot = [0, 0, 0];
            quad.rotation.set(degToRad * rot[0], degToRad * rot[1], degToRad * rot[2]);
            scl = this.tagcommon.scale;
            quad.scale.set(scl[0], scl[1], scl[2]);
            const linkURL = elem.link.URL;
            const imgPath = this.imgDir + elem.image.image;
            const tagInfo: TagInfo = { group: group, name: elem.name, connect: elem.connect, tag: quad, tagscale: scl, linkURL: linkURL, imgPath: imgPath };
            this.tagInfos.push(tagInfo);

            //初期状態（タグまたは画像）の選択
            if (elem.hide) {
                //this.EraseTagAndImage(tagInfo);   //タグ・画像両方非表示
                this.SwitchToTag(tagInfo);    //タグを表示
            } else {
                this.SwitchToTag(tagInfo);    //タグを表示
            }
        }
    }

    GoToURL() {
        //「ENTER]ボタン押下時
        let target: string = '_self';
        if (this.imagecommon.linkButton.linkTarget) target = this.imagecommon.linkButton.linkTarget;    //リンクターゲットをデフォルトから変更
        if (target == '_self') {
            location.href = this.currentTagInfo.linkURL;
        } else {
            window.open(this.currentTagInfo.linkURL);
        }
    }

    BackToCurrentTag() {
        //J3ThreeSubからコール。現在のパネル状態からタグ状態に戻る
        if (this.currentTagInfo) this.SwitchToTag(this.currentTagInfo);
    }
    SwitchToTag(taginfo: TagInfo) {
        this.section.style.display = 'none';
        taginfo.tag.visible = true;
        const scl = taginfo.tagscale;
        //console.log('SwitchToTag', taginfo.name, scl);
        taginfo.tag.scale.set(scl[0], scl[1], scl[2]);
    }
    SwitchToImage(taginfo: TagInfo) {
        //console.log('SwitchToImage', taginfo.name);
        this.section.style.display = 'block';
        this.imgElement.src = taginfo.imgPath;
        //console.log('taginfo.imgPath', taginfo.imgPath);
        taginfo.tag.visible = false;
        taginfo.tag.scale.set(0, 0, 0);
        this.currentTagInfo = taginfo;  //現在のタグインフォ
    }
    EraseTagAndImage(taginfo: TagInfo) {
        //console.log('EraseTagAndImage', taginfo.name);
        this.section.style.display = 'none';
        taginfo.tag.visible = false;
        taginfo.tag.scale.set(0, 0, 0);
    }

    DoAction(idname: string) {  //J3ThreeSubからコールされる
        const _groupid = idname.split('_')[1];
        if (_groupid != this.groupid) return;    //グループIDが異なる場合は何もしない
        //.log('DoAction', idname);

        const action = idname.split('_')[2].toLowerCase();   //アクションを取得
        if (action == 'close') {
            console.log('CLOSE');
            this.ShowTag(idname);
        } else if (action == 'openimage') {
            console.log('OPEN IMAGE');
            this.ShowImage(idname);
        } else if (action == 'gotolink') {
            console.log('GOTO LINK');
            this.OpenLink(idname);
        } else {
            console.log('ACTION not defined', action);
        }
    }

    OpenLink(idname: string) {
        const _groupid = idname.split('_')[1];
        if (_groupid != this.groupid) return;
        //console.log('GoToLink', idname);
        const _elemname = idname.split('_')[3];
        let target: string = '_self';
        if (this.imagecommon.linkButton.linkTarget) target = this.imagecommon.linkButton.linkTarget;
        for (const tagInfo of this.tagInfos) {
            if (tagInfo.name == _elemname) {
                if (target == '_self') {
                    location.href = tagInfo.linkURL;
                } else {
                    window.open(tagInfo.linkURL);
                }
                break;
            }
        }
    }

    ShowTag(imagename: string) {
        const _groupid = imagename.split('_')[1];
        if (_groupid != this.groupid) return;
        //console.log('ShowTag', imagename);
        this.OverlayOff();
        const _elemname = imagename.split('_')[3];
        for (const tagInfo of this.tagInfos) {
            if (tagInfo.name == _elemname) {
                this.SwitchToTag(tagInfo);
                break;
            }
        }
    }
    ShowImage(tagname: string) {
        const _groupid = tagname.split('_')[1];
        if (_groupid != this.groupid) return;
        //console.log('ShowImage', tagname);
        const _elemname = tagname.split('_')[3];
        this.OverlayOn();
        for (const tagInfo of this.tagInfos) {
            if (tagInfo.name == _elemname) {
                this.SwitchToImage(tagInfo);
                break;
            }
        }
    }

    EraseAll() {
        //console.log('EraseAll');
        //すべてのタグ・ビルボードを非表示にする
        for (const tagInfo of this.tagInfos) {
            this.EraseTagAndImage(tagInfo);
        }
    }


    ShowAllTags() {
        //console.log('ShowAllTags');
        //すべてのタグを表示、画像を非表示にする
        for (const tagInfo of this.tagInfos) {
            this.SwitchToTag(tagInfo);
        }
    }

    ShowAllImages() {
        console.log('ShowAllImages');
        //すべてのタグを非表示、画像を表示にする
        for (const tagInfo of this.tagInfos) {
            this.SwitchToImage(tagInfo);
        }
    }


    FilterConnectedBillboards(currentDomeName: string = '') {
        //現在のドーム名から番号部分を取り出す
        const domeNumStr: string = (currentDomeName.split('.')[0]).slice(1);
        //console.log('J3Billboard2DHelper:currentDome', domeNumStr, currentDomeName);

        for (const tagInfo of this.tagInfos) {
            this.EraseTagAndImage(tagInfo);    //タグ・画像を消去
            for (const num of tagInfo.connect) {
                if (num == domeNumStr) {
                    this.SwitchToTag(tagInfo); //タグを表示
                    break;
                }
            }
        }
    }

}